import { startOfDay, addMonths, isBefore, isAfter, isDate, isValid, isWeekend, isEqual, getDate } from "date-fns";
import { requiredMessage, capitalise, maxMonthFutureLimit, isWeeklyOrFortnightlyFrequency, INTERNATIONAL_FUNNELS } from "../utils/common";
var arhiFutureLimitMessage = function arhiFutureLimitMessage(fieldName, months) {
  return "Please choose a weekday within the next ".concat(months === 1 ? "month." : "".concat(months, " months."));
};
var arhiCreditCardExpiryMessage = function arhiCreditCardExpiryMessage() {
  return "Payment start date is before credit card expiry date.";
};
var VARIANTS = {
  ARHI: "payment start date"
};
var VARIANT_FUTURE_LIMIT_FUNCTION = {
  ARHI: arhiFutureLimitMessage,
  GU: maxMonthFutureLimit,
  IMAN: maxMonthFutureLimit,
  IWHI: maxMonthFutureLimit,
  ISHI: maxMonthFutureLimit
};
var validPaymentStartDate = function validPaymentStartDate(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var fieldName = arguments.length > 2 ? arguments[2] : undefined;
  var months = arguments.length > 3 ? arguments[3] : undefined;
  var frequency = arguments.length > 4 ? arguments[4] : undefined;
  var coverStartDate = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new Date();
  var creditCardExpiry = arguments.length > 6 ? arguments[6] : undefined;
  var error; // eslint-disable-line init-declarations
  var field = fieldName || VARIANTS[funnel] || VARIANTS.ARHI;
  var today = startOfDay(new Date()); //todo: not sure about this code change to fix the no undefined error for months in addMonths but it seems to work to pass the tests
  //what would have does addMonths return if you passed undefined for months before the typescript conversion?
  if (!coverStartDate) {
    coverStartDate = new Date();
  }
  if (typeof coverStartDate === "string") {
    coverStartDate = new Date(Date.parse(coverStartDate));
  }
  var futureLimit = startOfDay(addMonths(coverStartDate, months ? months : 1));
  if (value === null || typeof value === "undefined" || typeof value === "string" && value === "") {
    error = requiredMessage(field);
    return error;
  }
  if (typeof value === "string") {
    value = new Date(Date.parse(value));
  } // date must be a date object
  if (!isDate(value)) {
    error = "".concat(capitalise(field), " must be a valid date.");
  } else {
    // date must be a real date
    if (value && !isValid(value)) {
      error = "".concat(capitalise(field), " must be a valid date.");
    } // Date cannot be a weekend when we have selected weekly or fortnightly payment frequency for ARHI.
    // Assume date selected is within the correct time range as
    // invalid date range is checked after this
    if (!INTERNATIONAL_FUNNELS.includes(funnel) && value && frequency && isWeeklyOrFortnightlyFrequency(frequency) && isWeekend(value)) {
      error = arhiFutureLimitMessage(fieldName, months ? months : 1);
    } // date must be before cover start date, but can equal cover start date
    // this rule applies to arhi and any other white labels
    if (!INTERNATIONAL_FUNNELS.includes(funnel) && value) {
      if (!isEqual(value, coverStartDate)) {
        if (isBefore(value, coverStartDate)) {
          error = "".concat(capitalise(field), " cannot be before cover start date.");
        }
      }
    } // date must not be in the past
    if (value && isBefore(value, today)) {
      error = "".concat(capitalise(field), " cannot be in the past.");
    } // date must not be less than credit card expiry
    if (!INTERNATIONAL_FUNNELS.includes(funnel) && creditCardExpiry && value && isAfter(value, creditCardExpiry)) {
      error = arhiCreditCardExpiryMessage();
    } // date must not be beyond the allowed date range
    if (value && isAfter(value, futureLimit)) {
      var messageFunction = VARIANT_FUTURE_LIMIT_FUNCTION[funnel] || VARIANT_FUTURE_LIMIT_FUNCTION.ARHI;
      error = messageFunction(fieldName, months ? months : 1);
    } // date must be prior to the 28th day of the month when Payment Frequency is Monthly, Quarterly, Half-Yearly or Yearly
    if (frequency && !isWeeklyOrFortnightlyFrequency(frequency) && getDate(value) >= 28) {
      error = "".concat(capitalise(field), " must be prior to the 28th day of the month when Payment Frequency is Monthly, Quarterly, Half-Yearly or Yearly.");
    }
  }
  return error;
};
export default validPaymentStartDate;